<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = (e) => {
		buttons.blockNext();

		e.preventDefault();
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/verify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						registerFormStart();
						buttons.next();
						buttons.unblock();
						return true;
					}
				}

				buttons.unblock();
				return false;
			});
		});
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<div class="confirmation-hide">
			<h2>Register for the Johnson & Johnson Talcum Powder Class Action Investigation</h2>

			<p>
				If you were diagnosed with cancer after prolonged use of Johnson & Johnson Talcum Powder, you are
				encouraged to register for this investigation.
			</p>
		</div>
		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<!-- svelte-ignore a11y-label-has-associated-control -->
					<label class="">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</label>
					<div class="checkbox-container">
						<div class="checkbox">
							<Checkbox
								required="true"
								{disabled}
								bind:checked={$model.privacyPolicyConfirmed}
								label="I agree to the privacy policy"
								id="privacy"
							></Checkbox>
						</div>
					</div>
				</FormColumn>
			</FormRow>
		</div>

		<div class="register-btn-container confirmation-hide">
			<NavigationButtons
				showPrevious={false}
				bind:buttons
				nextPageLabel="REGISTER FOR THE INVESTIGATION"
				disableNext={!$model.privacyPolicyConfirmed}
				tealiumTag={false}
				pageName={pageTitle}
			></NavigationButtons>
		</div>

		<div class="form-content confirmation-hide">
			<FormRow>
				<FormColumn>
					<p>
						During completion of the registration form you will have the opportunity to save and close your
						form so that you can return and complete it at a later date.
					</p>
					<p>
						This form requests information relating to medical history, family medical history and social
						health history, and may take approximately 20-30 minutes to complete.
					</p>
					<p>
						Please make your best effort to answer each question as specifically as possible. If you cannot
						recall all of the details requested, please provide as much information as you can.
					</p>
					<p>
						If you are in any doubt about whether you need to complete this form, or whether you have
						suffered damages, please contact Shine Lawyers on
						<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
						<ClassActionEmailAddress></ClassActionEmailAddress>.
					</p>
				</FormColumn>
			</FormRow>

			<FormRow>
				<FormColumn></FormColumn>
			</FormRow>
		</div>
	</Form>
</PageSection>

<style>
	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		background-color: #333;
		color: white;
	}

	.logo {
		height: 40px;
	}

	.phone-number {
		font-size: 1.2rem;
		font-weight: bold;
	}

	h2 {
		text-align: center;
	}

	h2 {
		margin-bottom: 1rem;
	}

	.register-btn-container {
		text-align: center;
		margin: 2rem 0;
	}

	.checkbox-container {
		display: flex;
		margin-top: 1rem;
	}

	/* .checkbox {
        border: solid 1px darkgrey;
        padding: 13px;
    } */

	:global(.register-btn-container button) {
		background-color: #ff4500;
		color: white;
		border: none;
		padding: 0.75rem 1.5rem;
		font-size: 1rem;
		font-weight: bold;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	:global(.register-btn-container button:hover) {
		background-color: #ff5722;
	}

	/* label {
        font-weight: initial;
    } */
</style>
